import {
  SET_CHO_VAY_EDIT,
  SET_THUOCTINH_TAISAN_TM_CAM_DO,
  SET_LIST_TAI_SAN_CAM_CO_TM_CAM_DO,
  SET_CONFIG_TM_CAM_DO,
  SET_TAI_SAN_CAM_CO_TM_CAM_DO,
  GET_TAI_SAN_THEO_CHO_VAY_TMCD,
  GET_TAI_SAN_THUOC_TINH_TMCD,
  SET_LIST_LOAI_TAI_SAN_TM_CAM_DO,
  GET_LOAI_TAI_SAN_TMCD,
  SHOW_FORM_CAM_DO,
  GET_CONFIG_SYS_TMCD,
  SET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
  GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
  POST_CAM_DO,
  POST_CAM_DO_SUCCESS,
  POST_CAM_DO_FAILURE,
  CHECK_EDIT_CHO_VAY,
  CHECK_EDIT_CUSTOMER,
  SET_ENABLE_EDIT_CHO_VAY,
  SET_ENABLE_EDIT_CUSTOMER,
} from "./actionTypes";

export const setChoVayEdit = (dataEdit) => ({
  type: SET_CHO_VAY_EDIT,
  payload: dataEdit,
});
export const setTaiSanCamCo = (data) => ({
  type: SET_TAI_SAN_CAM_CO_TM_CAM_DO,
  payload: data,
});

export const setThuocTinhTaiSan = (data) => ({
  type: SET_THUOCTINH_TAISAN_TM_CAM_DO,
  payload: data,
});

export const setListTaiSanCamCo = (data) => ({
  type: SET_LIST_TAI_SAN_CAM_CO_TM_CAM_DO,
  payload: data,
});

export const setConfig = (data) => ({
  type: SET_CONFIG_TM_CAM_DO,
  payload: data,
});

export const setListLoaiTaiSan = (data) => ({
  type: SET_LIST_LOAI_TAI_SAN_TM_CAM_DO,
  payload: data,
});
export const getTaiSanTheoChoVayTMCD = (dataSearch) => ({
  type: GET_TAI_SAN_THEO_CHO_VAY_TMCD,
  dataSearch,
});

export const getThuocTinhTaiSanTMCD = (dataSearch) => ({
  type: GET_TAI_SAN_THUOC_TINH_TMCD,
  dataSearch,
});

export const getLoaiTaiSanTMCD = (dataSearch) => ({
  type: GET_LOAI_TAI_SAN_TMCD,
  dataSearch,
});
export const getLoaiTaiSanTMCDReloadTMLTS = (dataSearch) => ({
  type: GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
  dataSearch,
});

export const showFormCamDo = (data) => {
  return {
    type: SHOW_FORM_CAM_DO,
    payload: data,
  };
};
export const getConfigSysTMCD = (dataSearch) => ({
  type: GET_CONFIG_SYS_TMCD,
  dataSearch,
});
export const setListLoaiTaiSanReloadTMLTS = (data) => ({
  type: SET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
  payload: data,
});

export const postCamDo = (dataPost) => ({
  type: POST_CAM_DO,
  dataPost,
});

export const postCamDoSuccess = (data) => ({
  type: POST_CAM_DO_SUCCESS,
  payload: data,
});

export const postCamDoFailure = () => ({
  type: POST_CAM_DO_FAILURE,
});

export const checkEditChoVay = (choVayId) => ({
  type: CHECK_EDIT_CHO_VAY,
  choVayId,
});
export const setEnableEditChoVay = (data) => ({
  type: SET_ENABLE_EDIT_CHO_VAY,
  payload: data,
});

export const checkEditCustomer = (customerId) => ({
  type: CHECK_EDIT_CUSTOMER,
  customerId,
});
export const setEnableEditCustomer = (data) => ({
  type: SET_ENABLE_EDIT_CUSTOMER,
  payload: data,
});
